export enum ProgramStatus  {
    ComingSoon = 1,
    Started = 2,
    Finished = 4,
    Promotion = 6,
    Archived = 9
}